/**
 * categoryService — public category catalog API.
 */
import { get } from "../utils/api";

/**
 * List all active categories.
 * @param {string} locale — en, ru, he
 */
export async function fetchCategories(locale = "en") {
  try {
    const res = await get(`/public/categories?locale=${locale}`);
    return res.data || [];
  } catch (err) {
    console.warn("[categoryService] fetchCategories failed:", err.message);
    return [];
  }
}

/**
 * Get category detail by slug.
 */
export async function fetchCategoryBySlug(slug, locale = "en") {
  try {
    const res = await get(`/public/categories/${encodeURIComponent(slug)}?locale=${locale}`);
    return res.data || null;
  } catch (err) {
    console.warn("[categoryService] fetchCategoryBySlug failed:", err.message);
    return null;
  }
}
